(function () {
  'use strict';

  var REDIRECT_MS = 1500;
  var MOBILE_MAX = 749;
  var redirectTimer = null;

  function isMobileView() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  function checkoutUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root.replace(/\/?$/, '/') + 'checkout';
    }
    return '/checkout';
  }

  function cartUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root.replace(/\/?$/, '/') + 'cart';
    }
    return '/cart';
  }

  function postAddRedirectUrl() {
    // Land shoppers on the cart page (not checkout) so they can review their
    // order and keep shopping, on every device.
    return cartUrl();
  }

  function redirectToastSub() {
    return 'Choose what you’d like to do next.';
  }

  function cartAddUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url + '.js';
    return '/cart/add.js';
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (typeof drawer.close === 'function') {
      try { drawer.close(); } catch (_err) {}
    }
    drawer.classList.remove('active');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
  }

  function updateCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.wudy-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return cart;
      })
      .catch(function () {});
  }

  function scheduleCheckoutRedirect() {
    closeCartDrawer();
    clearTimeout(redirectTimer);
    redirectTimer = setTimeout(function () {
      closeCartDrawer();
      window.location.href = postAddRedirectUrl();
    }, REDIRECT_MS);
  }

  function showToast(title, sub, isError) {
    if (typeof window.showWpedAtcToast === 'function') {
      window.showWpedAtcToast(title, sub, isError);
      return;
    }
    var toast = document.querySelector('[data-wped-atc-toast]');
    if (!toast) return;
    var titleEl = toast.querySelector('[data-wped-toast-title]');
    var subEl = toast.querySelector('[data-wped-toast-sub]');
    if (titleEl) titleEl.textContent = title || 'Added to cart';
    if (subEl) subEl.textContent = sub || redirectToastSub();
    toast.classList.toggle('wped-atc-toast--error', !!isError);
    toast.hidden = false;
    toast.classList.add('is-visible');
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
      toast.hidden = true;
    }, isError ? 3200 : 1800);
  }

  function normalizeAddResponse(response, data) {
    if (!response.ok) throw data;
    if (data && data.status && Number(data.status) >= 400) throw data;
    if (data && data.description && !data.items && !data.id) throw data;
    return data;
  }

  function addItems(items, opts) {
    opts = opts || {};
    if (!items || !items.length) return Promise.reject(new Error('no items'));

    closeCartDrawer();

    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return normalizeAddResponse(response, data);
        });
      })
      .then(function (data) {
        closeCartDrawer();
        updateCartCount();
        if (opts.redirect === true) scheduleCheckoutRedirect();
        return data;
      });
  }

  function addVariant(variantId, quantity, opts) {
    return addItems([{ id: Number(variantId), quantity: quantity || 1 }], opts);
  }

  function parseFormItems(form) {
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) {
      var input = form.querySelector('[name="id"]');
      if (input) id = input.value;
    }
    if (!id) return [];
    var qty = Math.max(1, parseInt(fd.get('quantity') || '1', 10) || 1);
    return [{ id: Number(id), quantity: qty }];
  }

  function isProductAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.hasAttribute('data-wudy-atc-native')) return false;
    var action = (form.getAttribute('action') || '').toLowerCase();
    return form.classList.contains('wped-product-form__inner') ||
      !!form.closest('product-form') ||
      form.matches('form[action*="/cart/add"]') ||
      action.indexOf('/cart/add') !== -1;
  }

  function blockThemeCartDrawer(event) {
    if (!isProductAddForm(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function handleFormSubmit(event) {
    var form = event.target;
    if (!isProductAddForm(form)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var items = parseFormItems(form);
    if (!items.length) return;

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
    }

    addItems(items)
      .then(function () {
        showToast('Added to cart', redirectToastSub(), false);
      })
      .catch(function (err) {
        closeCartDrawer();
        var msg = (err && (err.description || err.message)) || 'Could not add to cart.';
        showToast('Something went wrong', msg, true);
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          if (label) btn.textContent = label;
        }
      });
  }

  window.WudyAtc = {
    REDIRECT_MS: REDIRECT_MS,
    MOBILE_MAX: MOBILE_MAX,
    isMobileView: isMobileView,
    checkoutUrl: checkoutUrl,
    cartUrl: cartUrl,
    postAddRedirectUrl: postAddRedirectUrl,
    redirectToastSub: redirectToastSub,
    closeCartDrawer: closeCartDrawer,
    scheduleCheckoutRedirect: scheduleCheckoutRedirect,
    addItems: addItems,
    addVariant: addVariant,
    showToast: showToast,
    updateCartCount: updateCartCount,
  };

  // NOT: blockThemeCartDrawer'i AYRI dinleyici olarak baglamayin —
  // stopImmediatePropagation() ayni hedefteki handleFormSubmit'i de oldurur
  // ve sepete ekleme calismaz. handleFormSubmit zaten ayni engellemeyi yapiyor.
  document.addEventListener('submit', handleFormSubmit, true);
})();
